import { render } from "./wallpaper.vue?vue&type=template&id=51b87c78&scoped=true"
import script from "./wallpaper.vue?vue&type=script&lang=js"
export * from "./wallpaper.vue?vue&type=script&lang=js"

import "./wallpaper.vue?vue&type=style&index=0&id=51b87c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b87c78"]])

export default __exports__